import React, {Fragment} from 'react'
import { Link } from 'react-router-dom'

const procesContent = [
    {
       icon: 'icon-24b',
       title: '요구사항 분석 및 범위 확정',
       desc: '비즈니스 목표와 현재 시스템 현황을 파악하여 최적의 구축 범위와 방향을 확정합니다.',
       margin: 'mb-40'
    },
    {
       icon: 'icon-25b',
       title: '아키텍처 설계 및 개발',
       desc: '확장성과 운영 안정성을 고려한 시스템 구조를 설계하고 애자일 방식으로 개발합니다.',
       margin: 'mb-40'
    },
    {
       icon: 'icon-26b',
       title: '배포 및 지속 운영 지원',
       desc: '무중단 배포와 초기 안정화 지원, 24/7 모니터링으로 안정적인 운영을 보장합니다.',
       margin: 'mb-65'
    }
]

const BlockStylFive = () => {
    return (
        <Fragment>
            <div className="block-style-six">
                {procesContent.map((val,i)=>(
                    <div key={i} className={`process-box ${val.margin}`}>
                        <div className="img">
                            <img src={`assets/img/icon/${val.icon}.svg`} alt={`${val.title} 아이콘`}/>
                        </div>
                        <div className="text-wrapper">
                            <h3 className="sect-title-two">{val.title}</h3>
                            <p>{val.desc}</p>
                        </div>
                    </div>
                ))}
                <div className="text-md-start text-center">
                    <Link className="theme_btn" to="/contact">프로젝트 문의하기</Link>
                </div>
            </div>
        </Fragment>
    )
}

export default BlockStylFive
